import { createAction, props } from '@ngrx/store';
import { CreateVorlage, VorlageListResource, VorlageResource } from './vorlage.model';
import { AufgabeResource } from '@schir-int-client/aufgabe-shared';

const PREFIX = '[Vorlage] ';

export const loadVorlageAction = createAction(
	PREFIX + 'Load Vorlage',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const loadVorlageSuccessAction = createAction(
	PREFIX + 'Load Vorlage Success',
	props<{
		vorlage: VorlageResource;
	}>()
);

export const loadVorlagenAction = createAction(PREFIX + 'Load Vorlagen');

export const loadVorlagenSuccessAction = createAction(
	PREFIX + 'Load Vorlagen Success',
	props<{
		vorlagen: VorlageListResource;
	}>()
);

export const saveVorlageAction = createAction(
	PREFIX + 'Save Vorlage',
	props<{
		createVorlage: CreateVorlage;
	}>()
);

export const deleteVorlageAction = createAction(
	PREFIX + 'Delete Vorlage',
	props<{
		vorlage: VorlageResource;
	}>()
);
